import React from 'react';

import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { Box } from 'shared/mui/Box';

import { CommissionsEditConditionsHeader } from './CommissionsEditConditionsHeader';
import {
  CommissionsBaseForm,
  CommissionsBaseFormValues,
} from '../components/CommissionsBaseForm/CommissionsBaseForm';
import {
  CommissionsConditionsForm,
  CommissionsConditionsFormValues,
} from '../components/CommissionsConditionsForm';
import { CommissionsFormSkeleton } from '../components/CommissionsFormSkeleton';

export type CommissionsEditFormValues = CommissionsBaseFormValues & {
  rate: CommissionsConditionsFormValues & {
    zeroed: boolean;
  };
  calculationMethod?: string | null;
};

export const CommissionsEditForm = () => {
  const { ready } = useNormalizeReferences({
    referenceFields: ['provider', 'merchant', 'currency', 'status', 'calculationMethod'],
  });

  if (!ready) {
    return <CommissionsFormSkeleton />;
  }

  return (
    <Box sx={{ paddingY: '24px', width: '100%' }}>
      <CommissionsBaseForm />
      <CommissionsEditConditionsHeader />
      <CommissionsConditionsForm />
    </Box>
  );
};
